<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-2 d-print-none d-flex align-items-center">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div class="col-sm-12 col-md-7 pt-3">
          <nav mat-tab-nav-bar>
            <a
              *ngIf="pendingApprovals.pendingApprovals?.total"
              mat-tab-link
              (click)="onTabChanged(1)"
              [routerLink]="['/pending-approvals']"
              [queryParams]="{ tab: 1 }"
              [active]="activeLink == 1"
            >
              Pending Actions
            </a>

            <a
              *ngIf="pendingApprovals.myPendingChanges?.total"
              mat-tab-link
              (click)="onTabChanged(2)"
              [routerLink]="['/pending-approvals']"
              [queryParams]="{ tab: 2 }"
              [active]="activeLink == 2"
            >
              My Submitted Actions
            </a>
          </nav>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav
      #sidenav
      class="builder-sidenav"
      mode="side"
      opened="true"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item style="height: unset">
          <div *ngIf="isExpanded || isShowing" class="full-width">
            <div class="left-table-container table-container mat-container">
              <mat-table
                [dataSource]="dataSourceCatalogs"
                *ngIf="activeLink == 1"
              >
                <ng-container matColumnDef="name">
                  <mat-header-cell mat-header-cell *matHeaderCellDef
                    >Pending Actions</mat-header-cell
                  >
                  <mat-cell *matCellDef="let e">
                    {{ e.name }}
                  </mat-cell>
                </ng-container>

                <mat-header-row
                  *matHeaderRowDef="tableColumns"
                ></mat-header-row>
                <mat-row
                  mat-row
                  *matRowDef="let row; columns: tableColumns"
                  (click)="navigateToCatalog(row.id)"
                ></mat-row>
              </mat-table>

              <mat-table
                [dataSource]="dataSourceMyChanges"
                *ngIf="activeLink == 2"
              >
                <ng-container matColumnDef="name">
                  <mat-header-cell mat-header-cell *matHeaderCellDef
                    >My Changes</mat-header-cell
                  >
                  <mat-cell *matCellDef="let e">
                    {{ e.name }}
                  </mat-cell>
                </ng-container>

                <mat-header-row
                  *matHeaderRowDef="tableColumns"
                ></mat-header-row>
                <mat-row
                  mat-row
                  *matRowDef="let row; columns: tableColumns"
                  (click)="navigateToCatalog(row.id)"
                ></mat-row>
              </mat-table>
            </div>
          </div>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content pt-3">
          <div id="tables ">
            <pending-approvals-catalogs
              [ngClass]="{ invisible: activeLink != 1 }"
              (updateCatalogs)="catalogsUpdate($event)"
            >
            </pending-approvals-catalogs>
            <pending-approvals-changes
              [ngClass]="{ invisible: activeLink != 2 }"
              (updateMyChanges)="myChangesUpdate($event)"
            ></pending-approvals-changes>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading" [message]="loadingMessage">
    <!-- Copyright 2017 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
  <!-- </overlay-loading> -->
</div>
